import { render, staticRenderFns } from "./TambahTanggungan.vue?vue&type=template&id=428c18b0&"
import script from "./TambahTanggungan.vue?vue&type=script&lang=js&"
export * from "./TambahTanggungan.vue?vue&type=script&lang=js&"
import style0 from "./TambahTanggungan.vue?vue&type=style&index=0&id=428c18b0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports